import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Cinematic%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20cozy%20dark%20room%20with%20subtle%20red%20and%20gold%20accents%2C%20professional%20photography%2C%20atmospheric%20mood%2C%20high%20detail%2C%20cinematic%20color%20grading&width=1920&height=1080&seq=hero-bg-01&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md rounded-full px-4 py-1.5 mb-6 border border-white/20">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <span className="text-white/90 text-xs md:text-sm">V5.2.0 全新版本已发布</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            随时随地
            <span className="text-primary-400">高清看片</span>
            <br />畅享免费影视体验
          </h1>

          <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            91影视看片app —— 海量影视资源每日更新，支持安卓和苹果设备，
            1080P超清画质流畅播放，离线缓存随时随地想看就看。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="#download"
              className="w-full sm:w-auto whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-full text-sm md:text-base transition-all duration-300 hover:scale-105 cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-android-line text-lg"></i>
              安卓版下载
            </a>
            <a
              href="#download"
              className="w-full sm:w-auto whitespace-nowrap bg-white/15 hover:bg-white/25 backdrop-blur-md text-white font-semibold px-8 py-3.5 rounded-full text-sm md:text-base transition-all duration-300 hover:scale-105 cursor-pointer border border-white/30 flex items-center justify-center gap-2"
            >
              <i className="ri-apple-line text-lg"></i>
              苹果版下载
            </a>
          </div>

          <div className="flex items-center justify-center gap-8 text-white/60 text-xs md:text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-green-400"></i>
              <span>安全无毒</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-download-cloud-2-line text-primary-400"></i>
              <span>5000万+下载</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-star-line text-yellow-400"></i>
              <span>4.9分好评</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}